import React, { ReactElement, useState } from 'react';

import Arrow from '@/components/forms/select/Arrow';
import Triangle from '@/components/forms/select/Triangle';

import Style from './Dropdown.module.css';

enum DirectionEnum {
    Left = 0,
    Right = 1,
}

export interface DropdownTypes {
    readonly children: ReactElement;
    readonly onSelect: (value: any) => void;
    readonly selectionOptions: Array<{ value: any, label: string }>;
    readonly withArrow?: boolean;
    readonly clickableChildren?: boolean;
    readonly direction: DirectionEnum,
    readonly isAction: boolean,
    readonly disabled?: boolean,
}

function Dropdown({
    children,
    onSelect,
    selectionOptions,
    withArrow = false,
    clickableChildren = false,
    direction,
    isAction,
    disabled = false,
}: DropdownTypes) {
    const [visible, setVisible] = useState(false);
    const toggleDropdown = () => setVisible(!visible);
    const checkAction: boolean = !(!isAction || isAction === undefined);
    const disabledClasses = disabled ? ' cursor-not-allowed opacity-50' : ' cursor-pointer opacity-1';

    const handleTypeSelection = (value: number) => {
        onSelect(value);
        toggleDropdown();
    };

    const directionStyle = () => {
        if (direction === DirectionEnum.Left) {
            return Style.left;
        }

        if (direction === DirectionEnum.Right) {
            return Style.right;
        }

        return null;
    };

    return (
        <div className={`${Style.dropdown} ${visible && Style.active}`}>
            <div className="min-w-[50px]">
                {clickableChildren ? (
                    <div>
                        <button
                            type="button"
                            disabled={disabled}
                            className={Style.dropbtn + disabledClasses}
                            onClick={toggleDropdown}
                        >
                            {children}
                            {withArrow && checkAction
                                && (
                                    <div
                                        className="absolute top-[12px] right-2"
                                        onClick={toggleDropdown}
                                        onKeyDown={(event) => {
                                            if (event.key === ' ' || event.key === 'Enter') {
                                                if (!disabled) {
                                                    toggleDropdown();
                                                }
                                                event.preventDefault();
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        {!disabled && <Triangle open={visible} />}
                                    </div>
                                )}
                        </button>
                    </div>
                ) : children}
                {withArrow && !checkAction
                    && (
                        <button
                            aria-label="Toggle dropdown"
                            type="button"
                            className={Style.dropbtn}
                            onClick={toggleDropdown}
                        >
                            <Arrow open={visible} />
                        </button>
                    )}
            </div>
            <div className={`${Style['content-wrapper']}`}>
                {visible && (
                    <div
                        className="fixed top-0 left-0 w-full h-full bg-transparent"
                        aria-hidden
                        onClick={toggleDropdown}
                    >
                        &nbsp;
                    </div>
                )}
                {visible && (
                    <div className={`${Style['dropdown-content']} ${directionStyle()}`}>
                        {selectionOptions.map(
                            (option) => (
                                <button
                                    key={`dropdown-${option.label}`}
                                    type="button"
                                    className="p-1"
                                    onClick={() => handleTypeSelection(option.value)}
                                >
                                    {option.label}
                                </button>
                            ),
                        )}

                    </div>
                )}
            </div>
        </div>
    );
}

export default Dropdown;
